import React from 'react';

interface PageHeadProps {
  title:    React.ReactNode;
  sub?:     React.ReactNode;
  actions?: React.ReactNode;
}

export const PageHead: React.FC<PageHeadProps> = ({ title, sub, actions }) => (
  <div className="page-head">
    <div>
      <h1>{title}</h1>
      {sub && <p className="sub">{sub}</p>}
    </div>
    {actions && <div className="actions">{actions}</div>}
  </div>
);
